import React from "react";
import PropTypes from "prop-types";
import ReportItem from "../ReportItem";
import styles from "./ReportList.module.css";
import { useTranslation } from "react-i18next";

export function ReportList({ header, items, onClick }) {
  const {t} = useTranslation();
  const colorMap = {
    "IBO(s)": "#91B6BB",
    "Platinum(s)": "#9E703C",
    "Emerald(s)": "#415364",
    "Diamond(s)": "#7F6A45",
  };

  return (
    <div className={styles.reportListContainer}>
      <div className={styles.header}>{t(header)}</div>
      <div className={styles.list}>
        {items.map((item, index) => (
          <ReportItem
            key={index}
            name={item.iboName}
            number={item.total.value}
            trend={item.total.trend}
            color={colorMap[header]}
            onClick={() => onClick(item)}
          />
        ))}
      </div>
    </div>
  );
}

ReportList.propTypes = {
  header: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      number: PropTypes.number.isRequired,
      trend: PropTypes.oneOf(["up", "neutral"]).isRequired,
      color: PropTypes.string.isRequired,
      showChevron: PropTypes.bool,
    })
  ).isRequired,
};
